import { NavigatorFile } from "@cruisen/contract"
import { NavigatorFileCard } from "../../atoms/NavigatorFileCard"
import styles from "./styles.module.scss"
import { makeAutoObservable } from "mobx"
import { observer } from "mobx-react-lite"
import { useMemo } from "react"
import { ImagePreviewModal } from "../../modals/ImagePreviewModal"
import { DocumentPreviewModal } from "../../modals/DocumentPreviewModal"

class UserMessageFileStore {
  selectedItem: { isImage: boolean; url: string; name: string } | null

  constructor() {
    this.selectedItem = null

    makeAutoObservable(this)
  }

  setSelectedItem(value: { isImage: boolean; url: string; name: string } | null) {
    this.selectedItem = value
  }
}

export const UserMessageFile = observer(({ file }: { file: NavigatorFile }) => {
  const state = useMemo(() => new UserMessageFileStore(), [])

  return (
    <>
      <div>
        {file.thumbnail ? (
          <img
            src={file.thumbnail}
            className={styles.navigatorImage}
            alt={file.fileName}
            onClick={() => {
              state.setSelectedItem({
                isImage: true,
                url: file.fileUrl,
                name: file.fileName,
              })
            }}
          />
        ) : (
          <div className={styles.fileCardWrapper}>
            <NavigatorFileCard
              file={{ name: file.fileName, type: "PDF" }}
              onClick={() => {
                state.setSelectedItem({
                  isImage: false,
                  url: file.fileUrl,
                  name: file.fileName,
                })
              }}
            />
          </div>
        )}
      </div>
      {state.selectedItem ? (
        <>
          {state.selectedItem.isImage ? (
            <ImagePreviewModal
              files={[
                {
                  fileName: state.selectedItem.name,
                  fileUrl: state.selectedItem.url,
                },
              ]}
              onClose={() => state.setSelectedItem(null)}
            />
          ) : (
            <DocumentPreviewModal
              fileUrl={state.selectedItem.url}
              onClose={() => state.setSelectedItem(null)}
            />
          )}
        </>
      ) : null}
    </>
  )
})
